/* eslint-disable no-useless-escape */
import { SSE } from './serverSentEvents';

export const validateEmail = (email) => {
  if (email.length === 0) return true;
  const reg =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!reg.test(email)) {
    return false;
  }
  return true;
};

export const apiPostFormDataHelper = async ({ url, payload = {}, requestHeaders }) => {
  try {
    let headers = {};
    if (!isEmpty(requestHeaders)) {
      headers = {
        ...requestHeaders,
      };
    }

    const responseData = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin', // include, *same-origin, omit
      headers,
      referrerPolicy: 'no-referrer',
      body: payload,
      redirect: 'follow',
    });
    return responseData.json();
  } catch (e) {
    return e || {};
  }
};
export const apiPutFormDataHelper = async ({ url, payload = {}, requestHeaders }) => {
  try {
    let headers = {};
    if (!isEmpty(requestHeaders)) {
      headers = {
        ...requestHeaders,
      };
    }

    const responseData = await fetch(url, {
      method: 'PUT',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin', // include, *same-origin, omit
      headers,
      referrerPolicy: 'no-referrer',
      body: payload,
      redirect: 'follow',
    });
    return responseData.json();
  } catch (e) {
    return e || {};
  }
};
export const apiPostHelper = async ({ url, payload = {}, contentType, requestHeaders }) => {
  try {
    let contentTypeText = 'application/json';
    if (contentType) {
      contentTypeText = contentType;
    }
    let headers = {
      Accept: 'application/json',
      'Content-Type': contentTypeText,
      'Accept-Language': localStorage.getItem('ss-lang'),
      // "Access-Control-Allow-Origin": "*"
    };
    if (!isEmpty(requestHeaders)) {
      headers = {
        ...headers,
        ...requestHeaders,
      };
    }
    // const responseData = await axios.post(URL, PAYLOAD, {
    //   headers
    // });
    const responseData = await fetch(url, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin', // include, *same-origin, omit
      headers,
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(payload),
    });
    return responseData.json();
  } catch (e) {
    return e || {};
  }
};
export const apiPutHelper = async ({ url, payload = {}, contentType, requestHeaders }) => {
  try {
    let contentTypeText = 'application/json';
    if (contentType) {
      contentTypeText = contentType;
    }
    let headers = {
      Accept: 'application/json',
      'Content-Type': contentTypeText,
    };
    if (!isEmpty(requestHeaders)) {
      headers = {
        ...headers,
        ...requestHeaders,
      };
    }
    // const responseData = await axios.post(URL, PAYLOAD, {
    //   headers
    // });
    const responseData = await fetch(url, {
      method: 'PUT',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin', // include, *same-origin, omit
      headers,
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(payload),
    });
    return responseData.json();
  } catch (e) {
    return e || {};
  }
};

export const apiGetHelper = async ({ url, payload = {}, contentType, requestHeaders }) => {
  try {
    let contentTypeText = 'application/json';
    if (contentType) {
      contentTypeText = contentType;
    }
    let headers = {
      Accept: 'application/json',
      'Content-Type': contentTypeText,
      'Accept-Language': localStorage.getItem('ss-lang'),
    };
    if (!isEmpty(requestHeaders)) {
      headers = {
        ...headers,
        ...requestHeaders,
      };
    }
    // const responseData = await axios.post(URL, PAYLOAD, {
    //   headers
    // });
    const responseData = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin', // include, *same-origin, omit
      headers,
      referrerPolicy: 'no-referrer',
    });
    return responseData.json();
  } catch (e) {
    return e.response || {};
  }
};

export const apiDeleteHelper = async ({ url, payload = {}, contentType, requestHeaders }) => {
  try {
    let contentTypeText = 'application/json';
    if (contentType) {
      contentTypeText = contentType;
    }
    let headers = {
      Accept: 'application/json',
      'Content-Type': contentTypeText,
      'Accept-Language': localStorage.getItem('ss-lang'),
      // "Access-Control-Allow-Origin": "*"
    };
    if (!isEmpty(requestHeaders)) {
      headers = {
        ...headers,
        ...requestHeaders,
      };
    }
    // const responseData = await axios.post(URL, PAYLOAD, {
    //   headers
    // });
    const responseData = await fetch(url, {
      method: 'DELETE',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin', // include, *same-origin, omit
      headers,
      referrerPolicy: 'no-referrer',
      body: JSON.stringify(payload),
    });
    return responseData.json();
  } catch (e) {
    return e || {};
  }
};

export const setSessionStorage = (data) => {
  if (typeof Storage !== 'undefined') {
    let { key, value, expiry } = data;
    const now = new Date().getTime();
    const item = {
      value,
      expiry: expiry ? now + expiry * 60 * 1000 : undefined,
    };
    sessionStorage.setItem(key, JSON.stringify(item));
  } else {
    console.log('No Web Storage support...');
  }
};
export const getSessionStorage = (key) => {
  if (typeof Storage !== 'undefined') {
    const itemStr = sessionStorage.getItem(key);
    if (!itemStr) {
      return;
    }
    const item = JSON.parse(itemStr);
    const { value, expiry } = item;
    const now = new Date();
    if (expiry && now.getTime() > expiry) {
      sessionStorage.removeItem(key);
      return;
    }
    return value;
  } else {
    console.log('No Web Storage support...');
  }
};

export const removeSessionStorage = (key) => {
  if (typeof Storage !== 'undefined') {
    return sessionStorage.removeItem(key);
  } else {
    console.log('No Web Storage support...');
  }
};

export const isEmpty = (obj) => {
  if (obj instanceof Date) {
    return false;
  }
  if (obj == null || obj === 'undefined') {
    return true;
  }

  const isNumber = (value) => Object.prototype.toString.call(value) === '[object Number]';
  const isNaN = (value) => isNumber(value) && value.toString() === 'NaN';

  if (isNumber(obj)) {
    return isNaN(obj);
  }

  if (obj.length > 0) {
    return false;
  }
  if (obj.length === 0) {
    return true;
  }

  if (typeof obj !== 'object') {
    return true;
  }

  const keys = Object.keys(obj);
  for (let i = 0, key = keys[i]; i < keys.length; i += 1) {
    if (hasOwnProperty.call(obj, key)) {
      return false;
    }
  }
  return true;
};

export const getParameterByName = (name) => {
  const url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export function getParameterByNameVariant(name) {
  // Use URL constructor to parse the URL
  const urlObj = new URL(window.location.href);

  // Get the fragment (everything after the '#')
  const fragment = urlObj.hash.substring(1);

  // Parse the fragment into key-value pairs
  const params = new URLSearchParams(fragment);

  // Return the value associated with the specified name
  return params.get(name);
}

export const returnEmailTime = (millis) => {
  let tim = new Date(millis);
  let timeArr = tim.toDateString().split(' ');
  let hr = Math.floor((millis / (1000 * 60 * 60)) % 24);
  let mins = Math.floor((millis / (1000 * 60)) % 60);
  hr = hr < 0 ? `0${hr}` : hr;
  mins = mins < 0 ? `0${mins}` : mins;
  let returnvalue = timeArr[0] + ', ' + timeArr[1] + ' ' + timeArr[2] + ', ' + timeArr[3] + '' + ' ' + `${hr}:${mins}`;

  return returnvalue;
};

export const returnLastActiveTime = (millis) => {
  if (millis === 0) return '';

  let tim = new Date(millis);

  let hours = tim.getHours();
  let ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  hours = hours.toString().padStart(2, '0');

  let minutes = tim.getMinutes().toString().padStart(2, '0');
  let date = tim.getDate().toString().padStart(2, '0');

  let monthNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
  let month = monthNames[tim.getMonth()];

  let year = tim.getFullYear().toString().slice(-2);

  let returnValue = `${hours}:${minutes} ${ampm} ${date}.${month}.${year}`;
  return returnValue;
};

export const isMobile = (() => {
  if (typeof window !== 'undefined') {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(window.navigator.userAgent || window.navigator.vendor || window.opera);
    return check;
  }
})();

export const epochToJsDate = (epochTime) => {
  // Your epoch time

  // Create a Date object from the epoch time
  const date = new Date(epochTime);

  // Define an array for month names
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  // Get the day, month, and year
  const day = date.getDate();
  const month = date.getMonth(); // Month is 0-based, so we'll need to add 1
  const year = date.getFullYear();

  // Format the date as "dd/Mon/yyyy"
  return `${day.toString().padStart(2, '0')}/${monthNames[month]}/${year}`;
};

export const bootIntercom = (name, email) => {
  try {
    window.Intercom('boot', {
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      name: name,
      email: email,
      created_at: new Date(), // Signup date as a Unix timestamp
      Entity: 'Sales Stack',
    });
  } catch (e) {
    console.log(e);
  }
};

export const shutdownIntercom = () => {
  try {
    window.Intercom('shutdown');
  } catch (e) {
    console.log(e);
  }
};

export const getURLParameterByName = (name) => {
  const url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) {
    return null;
  }
  if (!results[2]) {
    return '';
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export function isValidWebsite(url) {
  // Regular expression for a simple URL validation
  var urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?$/;

  // Test the URL against the pattern
  return urlPattern.test(url);
}

// A utility function to create a EventSource object and handling response
export const createEventSource = async ({
  url,
  payload,
  authToken,
  callback,
  updateSubject,
  finishGeneration,
  updateLeActivity,
  handleError,
  evtRef,
  trackEvent,
  retrainType,
}) => {
  let previousText = '';
  let previousSubject = '';

  const headers = {
    'Content-type': 'application/json; charset=UTF-8',
    ...(authToken && { authorization: `bearer ${authToken}` }),
  };

  const evsource = new SSE(url, {
    headers,
    payload: JSON.stringify(payload),
  });
  evtRef.current = evsource;
  evsource.addEventListener('error', ({ data }) => {
    if (data) {
      const response = JSON.parse(data);

      if (response?.code && response?.code !== 200) {
        handleError && handleError(response.message, retrainType);
      }
      if (response?.code === 200) {
        if (response?.activity) {
          updateLeActivity(response.activity);
        }
        trackEvent();
      }

      finishGeneration(response, retrainType);
    }
  });
  evsource.addEventListener('message', ({ data }) => {
    // Fallback handler for undefined event types
    if (data) {
      const currentStream = JSON.parse(data);
      if (currentStream && currentStream.text) {
        previousText = previousText + currentStream.text;
        callback(previousText, retrainType);
      }
      if (currentStream.subject) {
        previousSubject = previousSubject + currentStream.subject;
        updateSubject(previousSubject);
      }
    }
  });
  evsource.stream();
};

export const setNativeValue = (element, value) => {
  const valueSetter = Object.getOwnPropertyDescriptor(element, 'value').set;
  const prototype = Object.getPrototypeOf(element);
  const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value').set;

  if (valueSetter && valueSetter !== prototypeValueSetter) {
    prototypeValueSetter.call(element, value);
  } else {
    valueSetter.call(element, value);
  }
};
